import { render, staticRenderFns } from "./colaborador.vue?vue&type=template&id=e10490f4"
import script from "./colaborador.vue?vue&type=script&lang=js"
export * from "./colaborador.vue?vue&type=script&lang=js"
import style0 from "./colaborador.vue?vue&type=style&index=0&id=e10490f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports